import { footNoteUnfinishedRefsRe, hasInlinedFootNote } from './attributions';

export interface ITruncateTextParams {
    maxLength: number;
    linesNumber: number;
    lineSeparator?: string;
}

const hasLineSeparator = (text: string, lineSeparator: string) => text.includes(lineSeparator);

export const truncateText = (text: string, params: ITruncateTextParams) => {
    const { maxLength, linesNumber, lineSeparator = '\n' } = params;

    // if we have a line separator, we can truncate by lines
    if (hasLineSeparator(text, lineSeparator)) {
        const lines = text.split(lineSeparator);

        lines.length = Math.min(lines.length, linesNumber);

        return lines.join(lineSeparator);
    }

    let truncated = text.substring(0, maxLength);

    // if we have part of inlined footnotes, we need to remove them
    if (hasInlinedFootNote(truncated)) {
        truncated = truncated.replace(footNoteUnfinishedRefsRe, '');
    }

    return truncated;
};

type IEnhancement = (text: string) => string;

export const applyStringEnhancements = (text: string, enhancements: [boolean, IEnhancement][]) => {
    return enhancements.reduce((acc, [apply, enhancement]) => (apply ? enhancement(acc) : acc), text);
};
